import _ from 'lodash';
import { utils } from '../types';

const INITIAL_STATE = {
    geolocation: {
        latitude: 0.00,
        longitude: 0.00
    },
    error: undefined,
    clearFilterAction: () => { },
    isRoomListOpen: false,
    dropDownOptionsData: {},
    preferenceData: {},
    ticketTabs: [],
    inventoryTabs: [],
    userTabs: [],
    ticketColumns: {},
    reportColumns: {}
};

const utilsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case utils.SEARCH_MODULE_DATA_SUCCESS:
            return {
                ...state,
                searchData: action.payload,
            }
        case utils.SEARCH_MODULE_DATA_COUNT_SUCCESS:
            return {
                ...state,
                searchCount: action.payload
            }
        case utils.FILTER_MODULE_DATA_SUCCESS:
            return {
                ...state,
                filteredData: action.payload
            }
        case utils.CLEAR_FILTER_MODULE_DATA:
            return {
                ...state,
                filteredData: []
            }
        case utils.FILTER_MODULE_DATA_COUNT_SUCCESS:
            return {
                ...state,
                filterDataCount: action.payload
            }
        case utils.SET_INITIAL_FORM:
            return {
                ...state,
                setInitialForm: action.payload
            }
        case utils.SET_CLEAR_FILTER_BUTTON_ACTION:
            return {
                ...state,
                clearFilterAction: action.payload
            }
        case utils.UPDATE_LAT_LONG_SUCCESS:
            return {
                ...state,
                geolocation: action.payload
            }
        case utils.SET_ROOM_LIST_DATA:
            const state_data = { ...state };
            const { isRoomListOpen, activeCallId } = action.payload;
            if (isRoomListOpen !== undefined) state_data.isRoomListOpen = isRoomListOpen;
            if (activeCallId !== undefined) state_data.activeCallId = activeCallId;
            return state_data;

        case utils.SET_SELECTED_LOCATION_FROM_MAP: {
            return { ...state, selectedLocationOnMap: action.payload }
        }

        case utils.DROPDOWN_LOAD_SUCCESS: {
            const { ref, data, append } = action.payload;
            const currentData = state.dropDownOptionsData[ref] || [];
            const newData = append ? _.uniqBy([...currentData, ...data], 'id') : data;
            return { ...state, dropDownOptionsData: { ...state.dropDownOptionsData, [ref]: newData } }
        }

        case utils.GET_PREFERENCES_SUCCESS: {
            const { module, data, type, level_id } = action.payload;

            if (module === 'TICKET' && type === 'COLUMN') {
                return {
                    ...state,
                    ticketColumns: { ...state.ticketColumns, [level_id]: data[0].attributes }
                }
            }

            if (module === 'TICKET' && type === 'TAB') {
                return {
                    ...state,
                    ticketTabs: data[0].attributes
                }
            }

            if (module === 'INVENTORY' && type === 'TAB') {
                return {
                    ...state,
                    inventoryTabs: data[0].attributes
                }
            }

            if (module === 'USER' && type === 'TAB') {
                return {
                    ...state,
                    userTabs: data[0].attributes
                }
            }

            if (module === 'TABS') {
                let list = [];
                if (Array.isArray(data) && data.length > 0) {
                    list = data[0].attributes
                }
                return {
                    ...state,
                    sidebarList: list
                }
            }
            return {
                ...state,
                preferenceData: { ...state.preferenceData, [module]: data }
            }
        }

        case utils.GET_REPORT_COLUMNS_SUCCESS: {
            const { data, report } = action.payload;
            return { ...state, reportColumns: { ...state.reportColumns, [report]: data } };
        }

        default:
            return {
                ...state,
            };
    }
};

export default utilsReducer;


